import { render, staticRenderFns } from "./MatchConflictStep.vue?vue&type=template&id=5fe9ed5b"
import script from "./MatchConflictStep.vue?vue&type=script&lang=js"
export * from "./MatchConflictStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports